
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/education",
      function () {
        return require("private-next-pages/solutions/education.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/education"])
      });
    }
  